import { getAuthorization } from "../utils/token";

const BASE_URL = process.env.REACT_APP_API_URL;

const handleResponse = async (response, errorMessage, skipAuthErrorHandling = false) => {
  // If response is not ok, check for authentication errors
  if (!response.ok) {
    const data = await response.json();

    // Create an error object with status
    const error = data;
    error.status = data.status;
    error.message = data?.message || errorMessage;

    // If it's an authentication error, we might want to handle it globally
    // Skip auth error handling for specific endpoints like refresh token
    if (!skipAuthErrorHandling && (response.status === 401 || response.status === 403)) {
      // You can dispatch an event here that AuthContext listens to
      const event = new CustomEvent("logout-required", {
        detail: {
          status: response.status,
          message: data?.message || "Authentication required",
        },
      });
      window.dispatchEvent(event);
    }
    throw error;
  }
  // If the response "204 No Content", return an empty object
  if (response.status === 204) {
    return {};
  }
  return response.json();
};

/**
 * Handles API requests with consistent error handling and authentication
 * @param {string} url - The API endpoint path (without base URL)
 * @param {Object} options - Fetch options
 * @returns {Promise<Object>} - Parsed response data
 */
const fetchWithErrorHandling = async (url, options = {}) => {
  // Get fresh data directly from localStorage every time
  const i18nextLng = localStorage.getItem("i18nextLng") || "en";

  let space = null;
  try {
    const rawAccountData = localStorage.getItem("account");
    if (rawAccountData) {
      const accountData = JSON.parse(rawAccountData);
      space = accountData.space || null;
    }
  } catch (error) {
    console.error("Error parsing account data:", error);
    // Continue with space as null
  }

  options.headers = {
    ...options.headers,
    "Content-Type": "application/json",
    Authorization: getAuthorization(),
    "Space-Id": space,
    "Accept-Language": i18nextLng,
  };

  try {
    const response = await fetch(BASE_URL + url, options);
    // Pass skipAuthErrorHandling flag if present in options
    return handleResponse(response, "Something went wrong. Please try again.", options.skipAuthErrorHandling);
  } catch (error) {
    return Promise.reject(error);
  }
};

export { handleResponse, fetchWithErrorHandling };
